/**
 * coupon-block.js
 * Custom element que copia o código do cupom ao clicar no botão.
 * Mostra feedback visual ("Copiado!") por 2s.
 */
class CopyCoupon extends HTMLElement {
  connectedCallback() {
    this.btn        = this.querySelector('[data-copy-btn]');
    this.codeEl     = this.querySelector('[data-coupon-code]');
    this.defaultEl  = this.querySelector('[data-copy-default]');
    this.doneEl     = this.querySelector('[data-copy-done]');
    if (!this.btn || !this.codeEl) return;
    this.btn.addEventListener('click', () => this.copy());
  }

  async copy() {
    const code = this.codeEl.textContent.trim();
    try {
      await navigator.clipboard.writeText(code);
    } catch {
      // Fallback para browsers sem clipboard API
      const ta = document.createElement('textarea');
      ta.value = code;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
    }
    this.showFeedback();
  }

  showFeedback() {
    if (!this.defaultEl || !this.doneEl) return;
    this.defaultEl.hidden = true;
    this.doneEl.hidden = false;
    clearTimeout(this._t);
    this._t = setTimeout(() => {
      this.defaultEl.hidden = false;
      this.doneEl.hidden = true;
    }, 2000);
  }
}

if (!customElements.get('copy-coupon')) {
  customElements.define('copy-coupon', CopyCoupon);
}

(function fixMercadaoHeroBannerGap() {
  if (!document.body.classList.contains('template-index')) return;

  function apply() {
    const hero = document.querySelector('.hero-wrapper .hero');
    const mediaGrid = document.querySelector('.hero-wrapper .hero__media-grid');
    const contentWrapper = document.querySelector('.hero-wrapper .hero__content-wrapper');

    if (!hero || !mediaGrid) return;

    hero.style.setProperty('min-height', '0', 'important');
    hero.style.setProperty('--hero-min-height', 'auto', 'important');

    if (contentWrapper) {
      contentWrapper.style.setProperty('display', 'none', 'important');
    }

    mediaGrid.style.setProperty('position', 'relative', 'important');
    mediaGrid.style.setProperty('inset', 'auto', 'important');
    mediaGrid.style.setProperty('display', 'block', 'important');
    mediaGrid.style.setProperty('width', '100%', 'important');
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    mediaGrid.style.setProperty('aspect-ratio', isMobile ? '9 / 16' : '16 / 9', 'important');
    if (isMobile) {
      mediaGrid.style.setProperty('max-height', 'min(82svh, 680px)', 'important');
    }
    mediaGrid.style.setProperty('overflow', 'hidden', 'important');

    const heroSection = document.querySelector('.shopify-section:has(.hero-wrapper)');
    const marqueeSection = heroSection?.nextElementSibling;

    if (heroSection) {
      heroSection.style.setProperty('margin-block-end', '0', 'important');
      heroSection.style.setProperty('padding-block-end', '0', 'important');
    }

    if (marqueeSection?.querySelector('.marquee-promos-mercadao')) {
      marqueeSection.style.setProperty('margin-block-start', '0', 'important');
      marqueeSection.style.setProperty('padding-block-start', '0', 'important');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  document.addEventListener('shopify:section:load', apply);
  window.addEventListener('resize', apply);
})();
